export const PAY_PLANS_SEARCH_FIELDS = [
  { key: "employee_name", label: "Employee" },
  { key: "primary_position_name", label: "Primary Position" },
];
